module.exports = __webpack_public_path__ + "img/image_body-product_02.db2c9a7f.jpg";